import { Filter } from '@tencent/alloy-renderer';
import { AnimType } from '@tencent/slide-sdk-model';
import { AnimFilters } from '../anim-constants';
import { IAnimFilterOptions } from '../anim-interface';
import BlindsFilter from './effects/blinds';
import BounceFilter from './effects/bounce';
import CheckerboardFilter from './effects/checkerboard';
import CutFilter from './effects/cut';
import DissolveFilter from './effects/dissolve';
import RandomBarsFilter from './effects/random-bars';
import ShapeBoxFilter from './effects/shape-box';
import ShapeCircleFilter from './effects/shape-circle';
import ShapeDiamondFilter from './effects/shape-diamond';
import ShapePlusFilter from './effects/shape-plus';
import SplitFilter from './effects/split';
import StripsFilter from './effects/strips';
import WedgeFilter from './effects/wedge';
import WheelFilter from './effects/wheel';
import WipeFilter from './effects/wipe';

type FilterConstructor = new(options?: Partial<IAnimFilterOptions>) => Filter;
export default class AnimFiltersFactory {
    public static animFilterFnMap = new Map<AnimFilters, FilterConstructor>([
        [AnimFilters.BLINDS, BlindsFilter],
        [AnimFilters.CHECKERBOARD, CheckerboardFilter],
        [AnimFilters.WIPE, WipeFilter],
        [AnimFilters.CUT, CutFilter],
        [AnimFilters.RANDOMBAR, RandomBarsFilter],
        [AnimFilters.DISSOLVE, DissolveFilter],
        [AnimFilters.SPLIT, SplitFilter],
        [AnimFilters.STRIPS, StripsFilter],
        [AnimFilters.SHAPE_CIRCLE, ShapeCircleFilter],
        [AnimFilters.SHAPE_BOX, ShapeBoxFilter],
        [AnimFilters.SHAPE_DIAMOND, ShapeDiamondFilter],
        [AnimFilters.SHAPE_PLUS, ShapePlusFilter],
        [AnimFilters.WEDGE, WedgeFilter],
        [AnimFilters.WHEEL, WheelFilter],
        [AnimFilters.BOUNCE, BounceFilter],
    ]);

    // NOTE: AnimType 与 AnimFilter 对照 map，放此处只是为了好维护，后续添加滤镜不会漏掉
    public static animTypeFilterMap = new Map<AnimType, AnimFilters>([
        [AnimType.EntrBlinds, AnimFilters.BLINDS],
        [AnimType.ExitBlinds, AnimFilters.BLINDS],
        [AnimType.EntrCheckerboard, AnimFilters.CHECKERBOARD],
        [AnimType.ExitCheckerboard, AnimFilters.CHECKERBOARD],
        [AnimType.EntrWipe, AnimFilters.WIPE],
        [AnimType.ExitWipe, AnimFilters.WIPE],
        [AnimType.CutIn, AnimFilters.CUT],
        [AnimType.CutOut, AnimFilters.CUT],
        [AnimType.EntrRandomBars, AnimFilters.RANDOMBAR],
        [AnimType.ExitRandomBars, AnimFilters.RANDOMBAR],
        [AnimType.DissolveIn, AnimFilters.DISSOLVE],
        [AnimType.DissolveOut, AnimFilters.DISSOLVE],
        [AnimType.EntrSplit, AnimFilters.SPLIT],
        [AnimType.ExitSplit, AnimFilters.SPLIT],
        [AnimType.EntrStrips, AnimFilters.STRIPS],
        [AnimType.ExitStrips, AnimFilters.STRIPS],
        [AnimType.EntrShapeBox, AnimFilters.SHAPE_BOX],
        [AnimType.ExitShapeBox, AnimFilters.SHAPE_BOX],
        [AnimType.EntrShapeCircle, AnimFilters.SHAPE_CIRCLE],
        [AnimType.ExitShapeCircle, AnimFilters.SHAPE_CIRCLE],
        [AnimType.EntrShapeDiamond, AnimFilters.SHAPE_DIAMOND],
        [AnimType.ExitShapeDiamond, AnimFilters.SHAPE_DIAMOND],
        [AnimType.EntrShapePlus, AnimFilters.SHAPE_PLUS],
        [AnimType.ExitShapePlus, AnimFilters.SHAPE_PLUS],
        [AnimType.EntrWedge, AnimFilters.WEDGE],
        [AnimType.ExitWedge, AnimFilters.WEDGE],
        [AnimType.EntrWheel, AnimFilters.WHEEL],
        [AnimType.ExitWheel, AnimFilters.WHEEL],
        [AnimType.EntrBounce, AnimFilters.BOUNCE],
        [AnimType.ExitBounce, AnimFilters.BOUNCE],
    ]);

    public static createAnimFilter(animFilterType: AnimFilters, options: Partial< IAnimFilterOptions>): Filter | null  {
        const AnimFilter = this.animFilterFnMap.get(animFilterType);
        if (!AnimFilter) return null;
        return new AnimFilter(options);
    }
}
